import { isAfter } from 'date-fns'
import Step from '../../constants/Step'
import { createCycle, Cycle, ICycleFactory } from '../cycle/Cycle'
import { Order } from '../order/Order'

export interface IColumn {
  name:       string
  date:       Date
  step:       Step
  cycles:     Cycle[]
  productsCount: number
}

export interface IColumnFactory extends  Omit<IColumn, 'cycles'> {
  cycles: ICycleFactory[]
}

export class Column {
  name:       string
  date:       Date
  cycles:     Cycle[]
  step:       Step
  productsCount: number

  constructor(columnData: IColumn) {
    this.name       = columnData.name
    this.date       = columnData.date
    this.step       = columnData.step
    this.cycles     = columnData.cycles
    this.productsCount = columnData.productsCount
  }

  getAllOrders(): Order[] {
    return this.cycles.reduce<Order[]>((orders, cycle) => ([
      ...orders,
      ...cycle.orders,
    ]), [])
  }

  get upcomingCycle() {
    return this.cycles?.find(cycle => isAfter(new Date(cycle.pickupFrom), new Date()))
  }
}

export const createColumn = (columnData: IColumnFactory): Column => {
  const cycles = columnData.cycles.map(createCycle)
  const column = new Column({
    ...columnData,
    cycles,
  })

  column.cycles.forEach(cycle => cycle.setColumn(column))

  return column
}

export enum ColumnNumber {
  INCOMING = '0',
  IN_PROGRESS = '1',
  READY = '2',
}
